import { deleteEmptyObj, formatCST } from '@/utils/utils'
const state = {
  page: 1,
  total: 0,
  limit: 10,
  activeTab: '0',
  name: '',
  phone: '',
  channel: [],
  date: [],
  status: '',
  channelList: []
}

const actions = {
  // 获取学校数据
  async B2CGetData ({ state, commit }, playload) {
    let channelList = []
    if (state.channel.length === 1) {
      channelList = state.channelList.filter(row => row.value === state.channel[0])[0].children.map(row => row.value)
    } else {
      channelList = state.channel[1] && [state.channel[1]]
    }
    const data = {
      name: state.name,
      phone: state.phone,
      created_at_from: formatCST(state.date[0]),
      created_at_to: formatCST(state.date[1]),
      second_channel_list: channelList,
      statusId: state.status
    }
    deleteEmptyObj(data)
    const res = await API.post(`/edu/zone/channel/agent/consumer/list?page=${state.page}&limit=${state.limit}`, data)
    commit('setState', {
      module: 'B2C',
      key: 'total',
      value: res.data.total
    })
    return res
  },
  // 获取渠道列表
  async getChannelList ({ state }) {
    const res = await API.post(`/edu/zone/channel/agent/customer/channel/list`)
    return res
  },
  // 获取当前状态列表
  async getStatusList ({ state }) {
    const res = await API.post(`/edu/zone/channel/agent/customer/status/list`)
    return res
  }
}

const mutations = {
  B2CInit (state) {
    state.page = 1
    state.total = 0
    state.limit = 10
    state.name = ''
    state.phone = ''
    state.channel = []
    state.date = [new Date().getTime() - 3600 * 1000 * 24 * 179, new Date().getTime()]
    state.status = ''
  }
}

export default {
  state,
  actions,
  mutations
}
